import http from "../../http-common";

class ProductRightSideRelatedEventsService {
    getProductRightSideRelatedEventsService(productPath: string) {
        return http.get(`/right-side-section/products/related-events/${productPath}`);
    }
}

export default new ProductRightSideRelatedEventsService();
